import { sections } from "../SitemapData"

export default function getSectionSubsections(sectionId: number, includeHidden: boolean = false) {
    const section = sections.find(section => section.id === sectionId)
    if (!section || !section.subsections) throw Error("Undefined section or subsections")
    if (includeHidden) return section.subsections
    return section.subsections.filter(subsection => !subsection.hide)
}
